/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{Geometry as t}from"./Geometry.js";class e extends t{constructor(t,e,r,i,n,s){super(t,e),this.path=r,this.geometrySR=i,this.upVectorAlignment=n,this.stencilWidth=s}}function r(t){return"upVectorAlignment"in t}export{e as PathGeometry,r as isPathGeometry};
